module.exports = __webpack_public_path__ + "img/icon-email.c5931a74.svg";